export default "__VITE_ASSET__OI0yrWOj__"